import { CourseType } from '@cna/projects/ak-jura/shared/interfaces';
import { CanDeactivateGuard } from '../../../../../../../angular/ui/confirm-before-leave/can-deactivate-guard.service';
import { CourseListComponent } from './course-list/course-list.component';
import { Routes } from '@angular/router';
import { LearningViewComponent } from './learning-view/learning-view.component';
import { LearningModuleOverviewViewComponent } from './learning-module-overview-view/learning-module-overview-view.component';
import { LearningControlViewComponent } from './learning-control-view/learning-control-view.component';
import { LearningGuard } from './learning.guard';

// Add Path here, if wanna react on change in Effect
export const enum LearningRoutePaths {
    COURSE_OVERVIEW = 'courseOverview',
    LEARNING_CONTROL = 'moduleOverview/:moduleId/learningControl',
    MODULE_OVERVIEW = 'moduleOverview/:moduleId',
    LEARNING_VIEW = 'moduleOverview/:moduleId/readingView/:readingId',
}

export const routes: Routes = [
    {
        path: LearningRoutePaths.COURSE_OVERVIEW,
        pathMatch: 'full',
        canActivate: [LearningGuard],
        data: {
            alwaysAllowedCourseTypes: [CourseType.EducationCourse],
        },
        component: CourseListComponent, // Includes ModuleOverview || Sketch 19
    },
    {
        path: LearningRoutePaths.MODULE_OVERVIEW,
        component: LearningModuleOverviewViewComponent, // Module Detail Overview || Sketch 20
        canActivate: [LearningGuard],
        data: {
            reload: true,
        },
    },
    {
        path: LearningRoutePaths.LEARNING_VIEW,
        component: LearningViewComponent, //Content reading view || Sketch 21
        canActivate: [LearningGuard],
        canDeactivate: [CanDeactivateGuard],
        data: {
            isLearningViewActive: true,
        },
    },
    {
        path: LearningRoutePaths.LEARNING_CONTROL,
        canActivate: [LearningGuard],
        component: LearningControlViewComponent,
    },
];
